import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

type PersonSelectItemContainerProps = {
  isHighlighted?: boolean;
} & ComponentPropsWithoutRef<'li'>;

export const PersonSelectItemContainer = memo(
  ({ isHighlighted, className, ...props }: PersonSelectItemContainerProps) => (
    <li
      className={cn(
        'flex cursor-pointer items-center rounded-4 p-1.5 text-14 text-grey-12',
        isHighlighted && 'bg-grey-4',
        className,
      )}
      {...props}
    />
  ),
);

PersonSelectItemContainer.displayName = 'PersonSelectItemContainer';
